import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from '@reduxjs/toolkit'

// Import slices
import authSlice from './slices/authSlice'
import uiSlice from './slices/uiSlice'
import coursesSlice from './slices/coursesSlice'
import groupsSlice from './slices/groupsSlice'
import attendanceSlice from './slices/attendanceSlice'
import homeworkSlice from './slices/homeworkSlice'
import paymentsSlice from './slices/paymentsSlice'
import notificationsSlice from './slices/notificationsSlice'
import calendarSlice from './slices/calendarSlice'

// Persist configuration
const persistConfig = {
  key: 'eduna-root',
  storage,
  whitelist: ['auth', 'ui'], // Only persist auth and ui state
  version: 1
}

// Auth persist configuration (separate for sensitive data)
const authPersistConfig = {
  key: 'eduna-auth',
  storage,
  whitelist: ['token', 'refreshToken', 'user', 'isAuthenticated', 'permissions', 'allowedNavigation']
}

// Root reducer
const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authSlice),
  ui: uiSlice,
  courses: coursesSlice,
  groups: groupsSlice,
  attendance: attendanceSlice,
  homework: homeworkSlice,
  payments: paymentsSlice,
  notifications: notificationsSlice,
  calendar: calendarSlice
})

// Persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer)

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'persist/PAUSE',
          'persist/PURGE',
          'persist/REGISTER'
        ]
      }
    }),
  devTools: process.env.NODE_ENV !== 'production'
})

// Create persistor
export const persistor = persistStore(store)

// Export types for TypeScript (if needed later)
// Export types for TypeScript (commented out for JavaScript)
// export type RootState = ReturnType<typeof store.getState>
// export type AppDispatch = typeof store.dispatch